export default __webpack_public_path__ + "static/media/final_copy.641c1845.svg";